var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"filters__text-input",attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"change":function($event){_vm.debounce ? _vm.dChange($event) : _vm.change($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }